import ModelBase from "../../../../../../framework/core/mvvm/model_base";
import { JdTableData } from "../../data/jd_table_data";
import { NetMsgJd } from "../../../../net/net_msg_data_map_jd";
import { Jd } from "../../../../net/proto/proto_jd_game";

export class JdTableModel extends ModelBase{

    //牌局数据
    boardData:JdTableData.BoardData;

    //座位数据座位,不一定在战斗
    seatData:JdTableData.SeatPlayerData[];

    settingData:JdTableData.Setting;

    commonData:JdTableData.commonData;

    //牌局
    Init(){
        this.onInit();
    }

    //弃牌
    send_foldRsp(){
        this.sendMsg(NetMsgJd.FoldReq,{});
    }

    send_BetRsp(betCoin:number,isAllIn?:boolean){
        let data:Jd.IBetReq = {
            betCoin:betCoin,
            allIn:isAllIn,
        }
        this.sendMsg(NetMsgJd.BetReq,data);
    }

    send_Leave(){
        this.sendMsg(NetMsgJd.LeaveRoom,{});
    }

    send_ack(){
        if (this.commonData.event == 0) {
            return;
        }
        this.commonData.event = 0;
        let data:Jd.IAckReq = {
            ackId:this.commonData.ackId,
        }
        this.sendMsg(NetMsgJd.AckReq,data);
    }

    send_carrayCoin(coin:number,isAuto:boolean){
        let data:Jd.ICarryCoinReq = {
            coin:coin,
            autoCarry:isAuto,
        }
        this.sendMsg(NetMsgJd.CarryCoin,data)
    }

    findSeatInfoBySeatID(seatID:number):JdTableData.SeatPlayerData{
        if (!this.seatData) {
            cc.log('-->>>>seatData is null!')
            return null;
        }
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.seat_id === seatID) {
                    return data;
                }
            }
        }
        return null;
    }

    //移除
    removeSeatInfo(playerID:number){
        if (!this.seatData) {
            return;
        }
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_id == playerID) {
                    this.seatData.splice(index,1);
                    break;
                }
            }
        }
    }

    pushSeatInfo(data:JdTableData.SeatPlayerData){
        this.removeSeatInfo(data.player_id);
        this.seatData.push(data);
    }

    findSeatInfo(playerID:number):JdTableData.SeatPlayerData{
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_id == playerID) {
                    return data;
                }
            }
            
        }
        return null;
    }
    
    onInit(){};
}
